import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet-async';

const Legal = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Terms & Privacy - Premium SMM Panel</title>
        <meta 
          name="description" 
          content="Review our terms of service and privacy policy. Learn about how we protect your data and maintain transparency in our social media marketing services." 
        />
      </Helmet>
      
      <Navbar />
      
      <div className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-3xl font-extrabold text-gray-900 mb-8">Terms of Service & Privacy Policy</h1>
            
            <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-12">
              <div className="px-4 py-5 sm:px-6">
                <h2 className="text-xl font-bold text-gray-900">Terms of Service</h2>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">Last updated: April 15, 2023</p>
              </div>
              <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
                <div className="prose prose-blue max-w-none">
                  <h3>1. Acceptance of Terms</h3>
                  <p>
                    By accessing or using Premium SMM Panel services, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions, you may not access or use our services.
                  </p>
                  
                  <h3>2. Description of Service</h3>
                  <p>
                    Premium SMM Panel provides social media marketing services including but not limited to followers, likes, views, and other engagement metrics for various social media platforms.
                  </p>
                  
                  <h3>3. User Responsibilities</h3>
                  <p>
                    Users are responsible for providing accurate information when placing orders and maintaining the security of their accounts. Users must not use our services for any illegal purposes or in violation of any third-party platform's terms of service.
                  </p>
                  
                  <h3>4. Payment and Refunds</h3>
                  <p>
                    All payments are processed securely through our payment providers. Refunds may be issued at our discretion if services are not delivered as described. Refund requests must be submitted within 7 days of purchase.
                  </p>
                  
                  <h3>5. Service Limitations</h3>
                  <p>
                    We do not guarantee specific results from using our services. Social media platforms may change their algorithms or policies which may affect the visibility or accuracy of our service results.
                  </p>
                  
                  <h3>6. Termination</h3>
                  <p>
                    We reserve the right to terminate or suspend access to our services immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="bg-white shadow overflow-hidden sm:rounded-lg">
              <div className="px-4 py-5 sm:px-6">
                <h2 className="text-xl font-bold text-gray-900">Privacy Policy</h2>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">Last updated: April 15, 2023</p>
              </div>
              <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
                <div className="prose prose-blue max-w-none">
                  <h3>1. Information We Collect</h3>
                  <p>
                    We collect information you provide directly to us, such as your name, email address, payment information, and social media account details necessary to provide our services.
                  </p>
                  
                  <h3>2. How We Use Your Information</h3>
                  <p>
                    We use the information we collect to provide, maintain, and improve our services, process transactions, send communications, and for administrative purposes.
                  </p>
                  
                  <h3>3. Information Sharing</h3>
                  <p>
                    We do not sell your personal information to third parties. We may share information with service providers who perform services on our behalf, when required by law, or in connection with a business transfer.
                  </p>
                  
                  <h3>4. Data Security</h3>
                  <p>
                    We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
                  </p>
                  
                  <h3>5. Your Choices</h3>
                  <p>
                    You may update, correct, or delete your account information at any time by logging into your account. You may also opt-out of receiving promotional communications from us by following the instructions in those communications.
                  </p>
                  
                  <h3>6. Contact Us</h3>
                  <p>
                    If you have any questions about our Privacy Policy, please contact us at info@premiumsmmpanel.io.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="mt-8 text-center">
              <Link to="/" className="text-blue-600 hover:text-blue-500">
                Return to Home
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Legal;